module.exports = __webpack_public_path__ + "static/app-1dba35b9a4b1b0f1afaaa54298690976.png";